import Api from 'utils/api'

interface FetchProjectsParams {
  limit?: number
  offset?: number
  ordering?: string[]
  search?: string
  department?: number | string
}

export const fetchProjects = ({
  limit,
  offset,
  ordering,
  search,
  department,
}: FetchProjectsParams) => Api.get(['projects'], { limit, offset, ordering, search, department })
